<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :submit="handleSubmitFormAddRemoocCategory"
        :width="30"
        :title="$t('labels.remoocModule.remoocCategory.add')"
        :rules="rulesCategoryRemooc"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4">
                <hts-form-select
                    v-model="dataFormAddRemoocCategory.type"
                    v-model:text="dataFormAddRemoocCategory.name"
                    :label="$t('labels.remoocModule.containerCapacity')"
                    required
                    :items="towingCapacityList"
                    key-id="value"
                    key-label="label"
                    :color="props.color"
                    name="type"
                    prop="type" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.wheelNumber"
                    :label="$t('labels.vehicleModule.category.wheelNumber')"
                    :color="props.color"
                    required
                    type="number"
                    name="vehicleModule.category.wheelNumber"
                    prop="vehicleModule.category.wheelNumber" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.priceTires"
                    :label="$t('labels.vehicleModule.category.priceTires')"
                    :color="props.color"
                    required
                    type="number"
                    name="priceTires"
                    prop="priceTires" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.depreciationTires"
                    :label="$t('labels.vehicleModule.category.depreciationTires')"
                    :color="props.color"
                    required
                    type="number"
                    name="depreciationTires"
                    prop="depreciationTires" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.depreciationPeriodRemooc"
                    :label="$t('labels.depreciationPeriodRemoocByYear')"
                    :color="props.color"
                    required
                    type="number"
                    name="depreciationPeriodRemoocByYear"
                    prop="depreciationPeriodRemoocByYear" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.priceLiquidation"
                    :label="$t('labels.priceLiquidation')"
                    :color="props.color"
                    required
                    type="number"
                    name="priceLiquidation"
                    prop="priceLiquidation" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.depreciationRate"
                    :label="$t('labels.depreciationRateAmountYear')"
                    required
                    :color="props.color"
                    type="number"
                    name="depreciationRate"
                    prop="depreciationRate" />
                <hts-form-input
                    v-model="dataFormAddRemoocCategory.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import form from '../imports/remooc'
import { $api } from '#imports'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const dataFormAddRemoocCategory = reactive({ ...form.initRemoocCategory })
const emits = defineEmits(['close', 'refreshTables', 'newVehicleCategory'])
const goodsTypesList = ref<Array<String>>([])

const visible = ref(false)
const creating = ref(false)
const openAddRemoocCategory = () => {
  visible.value = true
}
defineExpose({
  openAddRemoocCategory
})
const closeOverSide = () => {
  visible.value = false
}

const undo = () => {
  Object.assign(dataFormAddRemoocCategory, { ...form.initRemoocCategory })
}
const towingCapacityList = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]
const handleSubmitFormAddRemoocCategory = () => {
  const api = $url.vehicle.remoocCategory.add
  creating.value = true
  $api(api, {
    body: {
      ...dataFormAddRemoocCategory
      // isTowingContainer: dataFormAddRemoocCategory.isTowingContainer === TowingCapacity.IS_TOWING
    }
  })
    .then((data: any) => {
      const resData: any = data?.data?.value
      if (resData?.success) {
        Object.assign(dataFormAddRemoocCategory, { ...form.initRemoocCategory })
        emits('refreshTables')
        process.client && $toast().success($t('labels.addSuccess'))
        emits('close')
        undo()
      }
      creating.value = false
      visible.value = false
    })
    .catch((e) => {
      creating.value = false
    })
}

const rulesCategoryRemooc = {
  depreciationPeriodRemoocByYear: 'min_value:1|integer',
  depreciationTires: 'min_value:1|integer',
  'vehicleModule.category.wheelNumber': 'required|min_value:1|integer',
  depreciationRate: 'required'
}
</script>
